import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PlateTypeProperties } from '@paragon/contract-library';

const initialState: readonly PlateTypeProperties[] = [];

const plateTypePropertiesSlice = createSlice({
  name: 'plateTypeProperties',
  initialState,
  reducers: {
    setPlateTypeProperties: (state, action: PayloadAction<readonly PlateTypeProperties[]>) => {
      state.push(...action.payload);
    },
  },
});

export const { setPlateTypeProperties } = plateTypePropertiesSlice.actions;
export const plateTypeProperties = plateTypePropertiesSlice.reducer;
